import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const HistoryGrommingpet = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const petId = queryParams.get("id");
  const ownerPhone = queryParams.get("phone");

  const [petdata, setPetData] = useState(null);
  const [owner, setOwnerData] = useState(null);
  const [groomingData, setGroomingData] = useState([]);
  const [messages, setMessages] = useState([]);
  const [staffList, setStaffList] = useState([]);
  const [GromingSession, setGromingSession] = useState({
    pet: "",
    petname: "",
    owner: "",
    ownername: "",
    comment: "No Comment from Customer",
    task: "",
    status: "",
    datee: "",
    week: "",
    hour: "",
    done: "",
    waitingtime: "3",
  });

  const [formData, setFormData] = useState({
    pet: petId || "",
    owner: "",
    subject: "",
    text: "",
    date: "",
    time: "",
    sender: "groomer",
  });

  const [responseMessage, setResponseMessage] = useState("");

  // Fetch OWNER info by phone
  useEffect(() => {
    if (ownerPhone) {
      axios
        .get(`/getowner?phone=${ownerPhone}`)
        .then((res) => setOwnerData(res.data))
        .catch((err) => console.error("Failed to fetch owner data:", err));
    }
  }, [ownerPhone]);

  // Fetch PET info by ID
  useEffect(() => {
    if (petId) {
      axios
        .get(`/fetch-pet/?id=${petId}`)
        .then((res) => setPetData(res.data))
        .catch((err) => console.error("Failed to fetch pet data:", err));
    }
  }, [petId]);

  // Fetch GROOMING history
  useEffect(() => {
    if (petId && ownerPhone) {
      axios
        .get(
          `/grooming-pet?phone=${ownerPhone}&pet_id=${petId}`
        )
        .then((res) =>
          setGroomingData(Array.isArray(res.data) ? res.data : [])
        )
        .catch((err) => console.error("Failed to fetch grooming data:", err));
    }
  }, [petId, ownerPhone]);

  // Fetch MESSAGES
  useEffect(() => {
    if (petId && owner?.id) {
      axios
        .get(
          `/message-pet?owner_id=${owner.id}&pet_id=${petId}`
        )
        .then((res) => setMessages(res.data))
        .catch((err) => console.error("Failed to fetch messages:", err));
    }
  }, [petId, owner]);

  // Update GromingSession when petdata changes
  useEffect(() => {
    if (!petdata || !petdata.owner) return;

    setGromingSession((prev) => ({
      ...prev,
      petname: petdata.name || "",
      ownername: petdata.owner.name || "",
      pet: petdata.id || "",
      owner: petdata.owner.id || "",
    }));

    setFormData((prev) => ({
      ...prev,
      owner: petdata.owner.id || "",
    }));
  }, [petdata]);

useEffect(() => {
    // Fetch staff list once on component mount
    const fetchStaff = async () => {
      try {
        const response = await axios.get('/staff/'); // Adjust API URL
        setStaffList(response.data);
      } catch (error) {
        console.error("Error fetching staff:", error);
      }
    };
    fetchStaff();
  }, []);
  // Handle Add Message
  const handleSubmit = async (e) => {
    e.preventDefault();

    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().split("T")[0];
    const formattedTime = currentDate.toTimeString().split(" ")[0];

    try {
      const messageData = {
        subject: formData.subject,
        text: formData.text,
        sender: formData.sender,
        pet: petId,
        owner: formData.owner,
        datee: formattedDate,
        time: formattedTime,
      };

      await axios.post(
        "/create-message/",
        messageData
      );

      setResponseMessage(`Message added successfully.`);

      setFormData({
        pet: petId || "",
        owner: formData.owner,
        subject: "No Subject",
        text: "",
        sender: "groomer",
      });
    } catch (error) {
      console.error(error);
      setResponseMessage(
        "An error occurred while submitting the message."
      );
    }
  };

  
/* Add groomingData */
 const handleSubmitGroomingData = async (e, pet) => {
  e.preventDefault();

  if (!pet || !petdata?.id || !petdata?.owner) {
    console.warn("Pet or Owner missing:", {
      pet,
      petId: petdata?.id,
      owner: petdata?.owner,
      ownerId: petdata?.owner?.id
    });
    alert("Pet or Owner data is missing.");
    return;
  }

  // Validate required comment field before sending
  if (!groomingData.comment || groomingData.comment.trim() === '') {
    alert("Comment is required and cannot be blank.");
    return;
  }

  const messageData = {
    petname: petdata.name || '',
    ownername: groomingData.ownername || petdata?.owner?.name || '',
    owner: petdata?.owner?.id || '',

    pet: petdata.id || '',
    comment: groomingData.comment || '',
    task: groomingData.task || '',
    phone: petdata.phone || '',
    phone2: groomingData.phone2,
    status: 1,
    datee: groomingData.datee || '',
    week: groomingData.week || '',
    hour: groomingData.hour || '',
    done:  0,
    waitingtime: 3,
    behaviour: groomingData.behaviour || 'Normal',
    catordog: petdata.catdog || '',
  };

  try {
    const response = await axios.post(
      '/create_grooming/',
      messageData
    );
    alert('Grooming added successfully.');
  } catch (error) {
    if (error.response) {
      console.error("Server responded with error:", error.response.data);
      alert(`Server error: ${JSON.stringify(error.response.data)}`);
    } else if (error.request) {
      console.error("No response received:", error.request);
      alert("No response from server. Check backend connection.");
    } else {
      console.error("Error setting up request:", error.message);
      alert(`Client error: ${error.message}`);
    }
  }
};


  return (

 <div className="responsive-wrapper" >

  {/* Left fixed profile section */}
      <div className="responsive-left fixed-left">
    <div className="name-hero">
      <div className="me-img">
      
      </div>

      <div className="name-text">
        <h1>{owner?.name || "Loading owner..."}</h1>
        <p>👤 {owner?.name || 'Loading name...'}</p>
        <p>📧 {owner?.email || 'Loading email...'}</p>
        <p>📱 {owner?.phone_mobile || 'Loading phone...'}</p>
      </div>
      <Link
  to={`/MakeNewAppointment?phone=${owner?.phone_mobile || '1'}&id=${owner?.id || '1'}`}
  style={{ textDecoration: 'none' }}
>
  <button
    type="button" // better use button type="button" inside Link
    className="square-button"
    style={{
      backgroundColor: "#4CAF50",
      color: "white",
      padding: "10px 20px",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer",
      fontSize: "1rem",
    }}
  >
    New Pet
  </button>
</Link>
    </div>
  </div>


     

         <div className="responsive-right "  >
 <div className="inner" style={{color: 'black'}}>
      <Link to={`/grooming/${petId}`}>Go to Grooming Page</Link>

      {petdata ? (
        <ul>
          <li className="big" style={{ textAlign: "center", width: "150%" }}>
            {petdata?.catdog} & {petdata?.catdog} Information
            <ul>
              <li className="big">{petdata?.catdog}</li>
              <li className="done" style={{ color: "red" }}>
                Name:
              </li>
              <li className="big">{petdata?.name}</li>

              <hr />
              <li className="done" style={{ color: "red" }}>
                Breed:
              </li>
              <li className="big">{petdata?.breed}</li>

              <hr />
              <li className="done" style={{ color: "red" }}>
                Owner Name:
              </li>
                <li className="big">👤 {owner?.name || 'Loading name...'}</li>

              <hr />
              <li className="done" style={{ color: "red" }}>
                Behaviour:
              </li>
              <li className="big">{petdata?.behaviour}</li>

              <hr />
              <li className="done" style={{ color: "red" }}>
                Gender:
              </li>
              <li className="big">{petdata?.gender}</li>

              <hr />
              <li className="done" style={{ color: "red" }}>
                AGE:
              </li>
              <li className="big">{petdata?.age}</li>

              <hr />
              <li className="done" style={{ color: "red" }}>
                Vaccinate:
              </li>
              <li className="big">{petdata?.vaccinated}</li>

              <hr />
              <li className="done" style={{ color: "red" }}>
                Neutered:
              </li>
              <li className="big">{petdata?.neutered}</li>
            </ul>
          </li>
        </ul>
      ) : (
        <p>Loading pet data...</p>
      )}


<main className="content">
    <section
      className="contact-wrap"
      style={{ width: '100%', maxWidth: '800px', background: '#fff', padding: '2rem', borderRadius: '1rem', boxShadow: '0 10px 20px rgba(0,0,0,0.1)' }}
    >
               <h3>Next Booking Grooming Session</h3>

      
<form  className="contact-form" 
onSubmit={(e) => handleSubmitGroomingData(e, petdata)}
>
<input type="hidden" name="petname" value={petdata?.name || ""} readOnly />
<input type="hidden" name="ownername" value={petdata?.owner?.name || ""} readOnly />
<input type="hidden" name="catordog" value={petdata?.catordog || ""} readOnly />
<input type="hidden" name="behaviour" value={petdata?.behaviour || ''} readOnly />
<input type="hidden" name="task" value={groomingData.task || ''} readOnly />
  <input type="hidden" name="status"   readOnly />
  <input type="hidden" name="done" value={groomingData.done || 0} readOnly />
  <input type="hidden" name="waitingtime" value={groomingData.waitingtime || '3'} readOnly />
  
<label>Client Comment</label>
<div>
  <textarea
    name="commenthim"
    className="textarea"
    rows={6}
    style={{
      width: "100%",
      padding: "10px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      resize: "vertical",
      fontSize: "1rem",
      fontFamily: "Arial, sans-serif",
      minHeight: "100px",
      maxHeight: "200px",
    }}
    value={groomingData.commenthim || ""}
    onChange={(e) => {
      if (e.target.value.length <= 300) {
        setGroomingData({ ...groomingData, commenthim: e.target.value });
      }
    }}
    placeholder="No Comment"
  />
  <div style={{ textAlign: "right", fontSize: "0.85rem", color: "#666", marginTop: "4px" }}>
    {(groomingData.commenthim || "").length} / 300
  </div>
</div>

<label>Groomer Comment During Grooming</label>
<div>
  <textarea
    name="commentus"
    className="textarea"
    rows={6}
    style={{
      width: "100%",
      padding: "10px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      resize: "vertical",
      fontSize: "1rem",
      fontFamily: "Arial, sans-serif",
      minHeight: "100px",
      maxHeight: "200px",
    }}
    value={groomingData.commentus || ""}
    onChange={(e) => {
      if (e.target.value.length <= 300) {
        setGroomingData({ ...groomingData, commentus: e.target.value });
      }
    }}
    placeholder="Nothing"
  />
  <div style={{ textAlign: "right", fontSize: "0.85rem", color: "#666", marginTop: "4px" }}>
    {(groomingData.commentus || "").length} / 300
  </div>
</div>



  <label>Task  Wash & Go...</label>
  <div className="input-block">
    <select
    name="task"
    value={groomingData.task || ''}
    onChange={(e) => setGroomingData({ ...groomingData, task: e.target.value })}
    className="form-control"
  >
    <option value="">Select</option>
    <option value="1">Wash & Go</option>
    <option value="2">Full Grooming</option>
    <option value="3">Nail</option>
    <option value="4">Teeth</option>
    <option value="5">Others</option>
  </select>
  </div>

  
  <label>Date</label>
  <div className="input-block">
    <input
      type="date"
      name="datee"
      className="form-control"
      value={groomingData.datee }
      onChange={(e) => setGroomingData({ ...groomingData, datee: e.target.value })}
      placeholder="YYYY-MM-DD"
    />
  </div>

<label>Which day</label>
<div className="input-block">
  <input
    type="text"
    name="week"
    list="weekdays"
    className="form-control"
    value={groomingData.week}
    onChange={(e) =>
      setGroomingData({ ...groomingData, week: e.target.value })
    }
    placeholder="e.g. Saturday"
    required
  />
  <datalist id="weekdays">
    <option value="Monday" />
    <option value="Tuesday" />
    <option value="Wednesday" />
    <option value="Thursday" />
    <option value="Friday" />
    <option value="Saturday" />
    <option value="Sunday" />
  </datalist>
</div>

<h2>Assign Staff to </h2>
<select
        name="staff"
        value={groomingData.staff || ''}
        onChange={(e) => setGroomingData({ ...groomingData, staff: e.target.value })}
        className="form-control"
      >
        <option value="">Select staff</option>
        {staffList.map((staff) => (
          <option key={staff.id} value={staff.id}>
            {staff.name}
          </option>
        ))}
      </select>

  <label>Which Hour</label>
<div className="input-block">
  <input
    type="text"
    name="hour"
    list="hour-options"
    className="form-control"
    value={groomingData.hour}
    onChange={(e) =>
      setGroomingData({ ...groomingData, hour: e.target.value })
    }
    placeholder="Select hour"
    required
  />
  <datalist id="hour-options">
    <option value="09:00" />
    <option value="10:00" />
    <option value="11:00" />
    <option value="12:00" />
    <option value="13:00" />
    <option value="14:00" />
    <option value="15:00" />
    <option value="16:00" />
  </datalist>
</div>


 
 
  <div>
    <button type="submit" className="square-button">Submit</button>
  </div>

  {responseMessage && <p>{responseMessage}</p>}

</form>

</section>

















</main>






 <section
  style={{
    padding: '4vw',
    fontFamily: 'Segoe UI, sans-serif',
    background: 'linear-gradient(to bottom right, #f0f4f8, #e6eef3)',
    minHeight: '100vh',
  }}
>
  <h2 style={{ fontSize: '2rem', marginBottom: '1rem', color: '#333' }}>Messages</h2>

  <div style={{ width: '100%', maxWidth: '900px' }}>
    {messages.map((grData, index) => (
      <div
        key={index}
        style={{
          borderLeft: '4px solid #4CAF50',
          background: '#ffffff',
          padding: '1rem 1.5rem',
          marginBottom: '1.5rem',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
        }}
      >
        <div style={{ fontSize: '0.9rem', color: '#888', marginBottom: '0.5rem' }}>
          📅 {grData.datee || 'N/A'} – 🕒 {grData.time || 'N/A'}
        </div>

        <div
          style={{
            fontSize: '1.2rem',
            fontWeight: '600',
            marginBottom: '0.5rem',
            color: '#c91f71ff',
          }}
        >
          <strong>Subject of Report:</strong>
          <br /> {grData.subject || 'N/A'}
        </div>

        <div style={{ fontSize: '1.2rem', lineHeight: '1.6', color: '#444' }}>
          <strong>{grData.sender} Message:</strong><br /> {grData.text || 'N/A'}
        </div>
      </div>
    ))}
  </div>
</section>



       <section
  className="contact-wrap"
  style={{
    width: "100%",
    maxWidth: "800px",
    margin: "0 auto",
    fontFamily: "Segoe UI, Roboto, sans-serif",
    padding: "2rem",
    backgroundColor: "#f9f9f9",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  }}
>
  <h1 style={{ fontSize: "1.8rem", marginBottom: "1.5rem", color: "#333" }}>Write a Message</h1>

  <form className="contact-form" onSubmit={handleSubmit}>
    <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>
Subject of Message    </label>
    <div style={{ marginBottom: "1.5rem" }}>
      <textarea
        value={formData.subject}
        onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
        className="textarea"
        rows={4}
        placeholder="Type subject here... Or Nothing"
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "6px",
          border: "1px solid #ccc",
          fontSize: "1rem",
        }}
      />
    </div>

    <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>
       
    </label>
    <div className="input-block" style={{ marginBottom: "1.5rem" }}>
      <select
        name="sender"
        className="form-control"
        value={formData.sender}
        onChange={(e) => setFormData({ ...formData, sender: e.target.value })}
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "6px",
          border: "1px solid #ccc",
          fontSize: "1rem",
        }}
      >
        <option value="groommer" selected>Pet Grooming</option>
        <option value="owner">Owner</option>
      </select>
    </div>

    <label style={{ fontWeight: "bold", display: "block", marginBottom: "0.5rem" }}>
      Passage 
    </label>
    <div style={{ marginBottom: "1.5rem" }}>
      <textarea
        name="text"
        className="textarea"
        rows={6}
        value={formData.text}
        onChange={(e) => setFormData({ ...formData, text: e.target.value })}
        placeholder="Type your message here..."
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "6px",
          border: "1px solid #ccc",
          fontSize: "1rem",
        }}
        required
      />
    </div>

    <div>
      <button
        type="submit"
        className="square-button"
        style={{
          backgroundColor: "#4CAF50",
          color: "white",
          padding: "10px 20px",
          border: "none",
          borderRadius: "6px",
          cursor: "pointer",
          fontSize: "1rem",
        }}
      >
        Submit
      </button>
    </div>

    {responseMessage && (
      <p style={{ marginTop: "1rem", color: "#333" }}>{responseMessage}</p>
    )}
  </form>
</section>
      {responseMessage && <p>{responseMessage}</p>}
    </div>
</div>
</div>

  );
};

export default HistoryGrommingpet;
